<template>
  <v-autocomplete
    variant="outlined"
    density="compact"
    v-model="inputValue"
    v-bind:items="revenues"
    v-bind:item-title="(item) => objectTranslator(item, 'REVENUE_NAME')"
    v-bind:item-value="(item) => item.REVENUE_ID"
    v-bind:rules="rules"
  ></v-autocomplete>
</template>

<script>
import { objectTranslator } from "@/helper/translator";
import validator from "@/helper/validator";

export default {
  name: "RevenuesCard",
  props: {
    modelValue: String,
  },

  data: () => ({
    rules: [validator.required],
  }),

  methods: {
    objectTranslator,
  },

  computed: {
    revenues: function () {
      return this.$store.state.ref.revenues;
    },

    inputValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },

  created() {
    this.$store.dispatch("ref/getRevenues");
  },
};
</script>
